import { observer } from 'mobx-react-lite';
import { confirmDialogCloseText } from 'owa-locstrings/lib/strings/confirmdialogclosetext.locstring.json';
import loc from 'owa-localize';
/* tslint:disable:jsx-no-lambda WI:47699 */
import store from '../store/store';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { OPAY_ENDPOINTS, OPAY_IFRAME_ID } from '../cardActions/TransactionAction';
import { getClientAuthToken } from 'owa-connectors';
import { useWindowEvent } from 'owa-react-hooks/lib/useWindowEvent';
import { trace } from 'owa-trace';
import * as React from 'react';
import hideOPayPanel from '../actions/hideOPayPanel';

interface OPayMessageEvent {
    action: string;
    data?: any;
}

export interface OPayContentProps {
    odataItemId: string;
    smtpAddressesSerialized: string;
}

export default observer(function OPayContent(props: OPayContentProps) {
    useWindowEvent('message', (event: MessageEvent) => {
        const messageOrigin = event.origin.toLowerCase();
        if (
            !Object.keys(OPAY_ENDPOINTS).some(
                key => OPAY_ENDPOINTS[key].indexOf(messageOrigin) !== 0
            )
        ) {
            return;
        }
        let postMessageData: OPayMessageEvent = null;
        try {
            postMessageData = JSON.parse(event.data);
        } catch (ex) {
            trace.warn('Unable to parse post message data: ' + event.data);
        }
        if (!postMessageData) {
            return;
        }
        const { action } = postMessageData;
        if (!action) {
            return;
        }
        switch (action) {
            case 'close':
                hideOPayPanel();
                break;
            case 'token':
                getClientAuthToken()
                    .then(token => {
                        const opayIframe = document.querySelector(
                            `#${OPAY_IFRAME_ID}`
                        ) as HTMLFrameElement;
                        opayIframe &&
                            opayIframe.contentWindow.postMessage(
                                JSON.stringify({
                                    action: 'token',
                                    token,
                                    messageContext: {
                                        messageId: props.odataItemId,
                                        smtpAddressesSerialized: props.smtpAddressesSerialized,
                                    },
                                    result: 'Success',
                                }),
                                messageOrigin
                            );
                    })
                    .catch(() => {
                        window.postMessage(
                            JSON.stringify({
                                action: 'token',
                                result: 'Failed',
                            }),
                            messageOrigin
                        );
                    });
                break;
            default:
                break;
        }
        // Todo: Handle refresh the message card on transaction complete
    });

    return (
        <Panel
            key="modalFlexPane"
            onDismiss={() => {
                hideOPayPanel();
            }}
            isOpen={store.shouldShowModalFlexPane}
            type={PanelType.smallFixedFar}
            closeButtonAriaLabel={loc(confirmDialogCloseText)}>
            {store.modalFlexPaneContent}
        </Panel>
    );
});
